/**
 * BookmarkDelete
 */

import Config from '../../Config';
import Util from '../../Util';
import ParamInfo from '../ParamInfo';

class BookmarkDelete {

	private paramInfo: any;

	private selector: string;

	private articleId: string;

	private boardAlias: string;

	constructor() {
		this.init();
	}

	private init() {
		this.paramInfo = new ParamInfo();
		this.paramInfo.setParamByUrl();
		this.selector = '.ncCommunityBoardList .delete';
		this.addEvent();
	}

	private scrapDelete( callback: any ) {
		const _post: any = Util.get( Config.scrapDelete({
			board: Config.board,
			articleId: this.articleId,
			boardAlias: this.boardAlias}), 'DELETE' );
		const _post$ = Util.from( _post );
		_post$.subscribe( ( data: any ) => {
			const result = data.toString();

			if ( result !== '-1' ) {

				if ( callback ) {
					callback( true );
				}

			} else {

				if ( callback ) {
					callback( true );
				}

			}
		}, ( data: any ) => {
			Config.apiError( data );
		});
	}

	private addEvent() {
		jQuery( 'body' ).on( 'click', this.selector, ( evt ) => {
			evt.preventDefault();

			const _$this = jQuery( evt.currentTarget );

			this.articleId = _$this.attr( 'data-articleid' );
			this.boardAlias = _$this.attr( 'data-alias' );

			Config.confirm( Config.L10N.alert_delete_article, () => {
				this.scrapDelete( ( bool: boolean ) => {
					if ( bool ) {
						location.href = 'bookmark?' + this.paramInfo.getParamIgnore( 'articleId' );
					} else {
						Config.alert( Config.L10N.alert_retry );
					}
				});
			}, () => {
				// reject
			});
		});
	}
}

export default BookmarkDelete;
